import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import CustomCkeditor from "../../../common/customeditor";
import * as pageServices from "../../../services/pages.services";
import { SWAL_SETTINGS, MENU_LOCATION, showFilterlist, INPUT_LENGTH_50, INPUT_LENGTH_100, FOOTER_LOCATION } from "../../../../../utils/Constants";
import {
  DT,
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { COMMON_INPUT_VALIDATION } from "../../../../../utils/commonValidations";
import * as Yup from "yup";
const PageAdd = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation()
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [initialValues, setInitialValues] = useState({
    title_en: "",
    // title_hi: "",
    name: "",
    slug: "",
    short_description_en: "",
    // short_description_hi: "",
    meta_tags: "",
    meta_keyword: "",
    menu_location: "",
    footer_location: "",
    description_en: "",
    // description_hi: "",
  });

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_pages"), url: "/admin/cms/pages/list/1" },
    { title: t("link_add"), url: "" },
  ];

  useEffect(() => {
    setInitialValues({
      title_en: state && state?.title_en ? state?.title_en : "",
      // title_hi: state && state?.title_hi ? state?.title_hi : "",
      slug: state && state?.slug ? state?.slug : "",
      status: state && state?.status ? state.status : "",
      menu_location: state && state?.menu_location ? state.menu_location : "",
      footer_location: state && state?.footer_location ? state.footer_location : "",
      short_description_en: state && state?.short_description_en ? state?.short_description_en : "",
      // short_description_hi: state && state?.short_description_hi ? state?.short_description_hi : "",
      description_en: state && state?.description_en ? state?.description_en : "",
      // description_hi: state && state?.description_hi ? state?.description_hi : "",

    });
    setDataLoaded(true);
  }, []);

  const validationSchema = Yup.object().shape({
    title: Yup.string().trim()
      .concat(COMMON_INPUT_VALIDATION)
  })

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          initialValues={initialValues}
          validateOnBlur={false}
          validationSchema={validationSchema}
          validate={(values) => {
            const error = {};
            if (!values.title_en || !values.title_en.trim())
              error.title_en = t("label_title_error");
            if (values.title_en.length > INPUT_LENGTH_50)
              error.title_en = DT(t("validation_err_reached_maximum_length"), [INPUT_LENGTH_50]);
            if (!values.slug || !values.slug.trim())
              error.slug = t("label_slug_error");
            if (values.slug.length > INPUT_LENGTH_50)
              error.slug = DT(t("validation_err_reached_maximum_length"), [INPUT_LENGTH_50]);
            const slugPattern = /^[a-zA-Z0-9-_]+$/;
            if (values.slug && !slugPattern.test(values.slug)) {
              error.slug = t("validation_err_invalid_slug");
            }
            if (!values.status)
              error.status = t("validation_err_status_required");
              if (!values.type)
              error.type = t("Type is required");
            if (!values.menu_location)
              error.menu_location = t("validation_err_menu_location");
            if (values.menu_location === "footer" && !values.footer_location)
              error.footer_location = "validation_err_footer_location";
            if (!values.short_description_en || !values.short_description_en.trim())
              error.short_description_en = t("label_short_description_error");
            if (!values.description_en || !values.description_en.trim())
              error.description_en = t("label_long_description_error");

            return error;
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);
            globalLoader(true);
            console.log(values);
            let formData = new FormData();
            formData.append("title_en", values.title_en);
            formData.append("slug", values.slug);
            formData.append("status", Number(values.status));
            formData.append("menu_location", values.menu_location);
            formData.append("footer_location", values.footer_location);
            formData.append("short_description_en", values.short_description_en);
            formData.append("description_en", values.description_en);
            formData.append("type", values.type);
            pageServices
              .Add(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    resetForm({ values: "" });
                    globalLoader(false);
                    navigate(`/admin/cms/pages/list/1`);
                  }, 1000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                  globalLoader(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("add_cms")}</h6>
                      </div>
                      <div className="row row-sm">
                        {/* <div className="col-lg-6 text-center form-group">
                          <label htmlFor="name" className="text-left d-flex">
                          {t("label_name")}:
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Page Name - Backend Only</Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input
                            name="name"
                            id="name"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            className="form-control"
                          />
                        </div> */}

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="title_en" className="text-left d-flex">
                            {t("label_page_title_en")}:<span className="requirestar">*</span>
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("tooltip_page_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input
                            name="title_en"
                            id="title_en"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title_en}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title_en && touched.title_en && t(errors.title_en)}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="slug" className="text-left d-flex">
                            {t("label_slug_of_page")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="slug"
                            id="slug"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.slug}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.slug && touched.slug && errors.slug}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            {t("list_heading_status")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="status"
                              id="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                              className="form-control" >

                              {(showFilterlist).map((value, i) => {
                                return (
                                  <option key={i} value={value.status__id}>{t(`${value.name}`)}</option>
                                )
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.status &&
                              touched.status &&
                              errors.status}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="menu_location" className="text-left d-flex">
                            {t("label_menu_of_the_page")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="menu_location"
                              id="menu_location"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.menu_location}
                              className="form-control" >

                              <option value="">{t("input_select_text")}</option>
                              {Object.keys(MENU_LOCATION).map((key, i) => {
                                return (
                                  <option key={i} value={MENU_LOCATION[key]}>{t(`${key}`)}</option>
                                )
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.menu_location &&
                              touched.menu_location &&
                              errors.menu_location}
                          </span>
                        </div>

                        {values.menu_location === "footer" &&
                          <div className="col-md-6 text-center form-group">
                            <label htmlFor="footer_location" className="text-left d-flex">
                              {t("label_location_of_the_footer")}:
                              <span className="requirestar">*</span>{" "}
                            </label>
                            <div className=" select-down-arrow">
                              <select
                                name="footer_location"
                                id="footer_location"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.footer_location}
                                className="form-control cp" >

                                <option value="">{t("input_select_text")}</option>
                                {Object.keys(FOOTER_LOCATION).map((key, i) => {
                                  return (
                                    <option key={i} value={FOOTER_LOCATION[key]}>{t(`${key}`)}</option>
                                  )
                                })}
                              </select>
                            </div>
                            <span className="text-danger d-flex text-left">
                              {errors.footer_location &&
                                touched.footer_location &&
                                t(errors.footer_location)}
                            </span>
                          </div>
                        }

                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_tags"
                            className="text-left d-flex"
                          >
                             {t("meta_tags")}:{" "}
                          </label>
                          <textarea
                            name="meta_tags"
                            id="meta_tags"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_tags}
                            className="form-control"
                          />
                        </div> */}
                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_keyword"
                            className="text-left d-flex"
                          >
                             {t("meta_keywords")}:{" "}
                          </label>
                          <textarea
                            name="meta_keyword"
                            id="meta_keyword"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_keyword}
                            className="form-control"
                          />
                        </div> */}

                        <div className="col-lg-12 text-center form-group required">
                          <label htmlFor="short_description_en" className="text-left d-flex" >
                            {t("label_short_description_en")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="short_description_en"
                            id="short_description_en"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.short_description_en}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.short_description_en &&
                              touched.short_description_en &&
                              errors.short_description_en}
                          </span>
                        </div>

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="description_en" className="text-left d-flex">
                            {t("label_long_description_en")}:<span className="requirestar">*</span>
                          </label>
                          <CustomCkeditor
                            fieldname={"description_en"}
                            setFieldValue={setFieldValue}
                            value={values.description_en}
                            setFieldTouched={setFieldTouched}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.description_en &&
                              touched.description_en &&
                              errors.description_en}
                          </span>
                        </div>
                        

                         <div className="col-md-12 text-center form-group">
                            <label htmlFor="type" className="text-left d-flex">
                              {t("Type")}:
                              <span className="requirestar">*</span>{" "}
                            </label>
                            <div className=" select-down-arrow">
                              <select
                                name="type"
                                id="type"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                                className="form-control cp" >

                                <option value="">{t("Select Type")}</option>
                                <option value="user">{t("User")}</option>
                                <option value="astrologer">{t("Astrologer")}</option>
                              </select>
                            </div>
                            <span className="text-danger d-flex text-left">
                              {errors.type &&
                                touched.type &&
                                t(errors.type)}
                            </span>
                          </div>

                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                          <butthu
                            className="btn ripplehutn-secondary"
                            type="button"
                            disabled={submitted ? true : null}
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </butthu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <></>
      )}
    </>
  );
};

export default PageAdd;
